const calFontStyle = (font, size, lineHeight = "normal", letterSpacing = "normal") => {
    return `
        font-family: ${font};
        font-size: ${size};
        line-height: ${lineHeight};
        letter-spacing: ${letterSpacing};
    `
}

const font = {
    "tiny": calFontStyle("normal", "8px"),
    "extra_small": calFontStyle("normal", "12px"),
    "extra_small_bold": calFontStyle("bold", "12px"),
    "small": calFontStyle("normal", "16px"),
    "small_bold": calFontStyle("bold", "16px"),
    "medium": calFontStyle("normal", "20px"),
    "medium_bold": calFontStyle("bold", "20px"),
    "large": calFontStyle("normal", "24px"),
    "large_bold": calFontStyle("bold", "24px"),
    "extra_large": calFontStyle("normal", "32px"),
    "heading": calFontStyle("bold", "48px"),
}

const color = {
    // Basic List
    "white": "#FFFFFF",
    "grey1": "#EEF0F2",
    "grey2": "#DFDFE7",
    "grey3": "#B2B2B2",
    "grey4": "#8D8D8D",
    "black": "#1F2024",

    // State List
    "major": "#ED3241",
    "error": "#DC3545",
    "error_light": "#F8D7DA",
}

const breakpoints = {
    mobile: '768px',
    tablet: '1280px',
    desktop: '1200px',
}

const theme = {
    font,
    color,
    breakpoints,
}

export default theme